<div *ngIf="accessdenied" class="row">
    <div class="col-md-12 no-padding">
        <app-access-denied></app-access-denied>
    </div>
</div>
<div *ngIf="!accessdenied" class="row">
    <div class="col-md-12">
        <div class="row col-xs-12 col-sm-12 col-lg-12 largTextbox no-padding" style="box-shadow: 0 2px 6px 0 hsl(0deg 0% 0% / 20%); background-color: #00a6b6; color: white; border-top-right-radius: 5px; border-top-left-radius: 5px; ">
            <h6 style="font-size: 14px; height: 35px; margin: 0px; padding: 10px; border-top-left-radius: 5px; border-top-right-radius: 5px;" class="sub-title">
                <span style="float:left">Document details</span>
            </h6>
        </div>
        <div class="row col-xl-12 block-style" style="border-top-left-radius: 0; border-top-right-radius: 0;">
            <div class="col-md-8 col-sm-8 ">
                <div class="col-md-12 col-sm-12 col-xs-12 b20-margin no-padding r20-padding l20-padding t30-padding b20-padding myG-box">
                    <div class="col-md-12 col-sm-12 col-xs-12 no-padding ">
                        <div class="form-group col-md-12 col-sm-12 col-xs-12  no-padding" style="margin-bottom:5px">
                            <div class="form-floating">
                                <input style="background-color: white; border: 0px;" type="text" disabled class="form-control" id="floatingInputValueSubject" [(ngModel)]="document.file.fileName">
                                <label for="floatingInputValueSubject">Document file name</label>
                            </div>

                        </div>
                        
                        <div class="form-group col-md-12 col-sm-12 col-xs-12  no-padding" style="margin-bottom:5px">
                            <div class="form-floating">
                                <input style="background-color: white; border: 0px;" type="text" disabled class="form-control" id="floatingInputValueSubject" [(ngModel)]="document.file.contentType">
                                <label for="floatingInputValueSubject">Document content type</label>
                            </div>

                        </div>
                        <div class="form-group col-md-12 col-sm-12 col-xs-12  no-padding" style="margin-bottom:5px">
                            <div class="form-floating">
                                <input style="background-color: white; border: 0px;" type="text" disabled class="form-control" id="floatingInputValueSubject" [(ngModel)]="document.file.fileSize_mb">
                                <label for="floatingInputValueSubject">Document size (MB)</label>
                            </div>

                        </div>
                        <div class="form-group col-md-12 col-sm-12 col-xs-12  no-padding" style="margin-bottom:5px">
                            <div class="form-floating">
                                <input style="background-color: white; border: 0px;"  type="text" disabled class="form-control" id="floatingInputValueSubject" [(ngModel)]="document.file.documentCenterFolder.folderName">
                                <label for="floatingSelect">Folder</label>
                            </div>
                        </div>

                        <div class="form-group col-md-12 col-sm-12 col-xs-12  no-padding" style="margin-bottom:5px">
                            <div class="form-floating">
                                <input style="background-color: white; border: 0px;" type="text" disabled class="form-control" id="floatingInputValueSubject" [(ngModel)]="document.file.documentType.type">
                                <label for="floatingSelect">Document type</label>
                            </div>
                        </div>
                        <div class="form-group col-md-12 col-sm-12 col-xs-12 no-padding" style="margin-bottom:5px">

                            <div class="form-floating">
                                <textarea  [(ngModel)]="document.file.description" style="background-color: white; border: 0px; height: 150px" class="form-control" placeholder="describe the document here..." id="floatingTextareaDescription"></textarea>
                                <label for="floatingTextareaDescription">Document description</label>
                            </div>

                        </div>
                        <div class="row" style="margin-bottom:5px">
                            <div class="col-md-12 col-sm-12 col-xs-12">
                                <span *ngIf="document.file.expireDate" style="color:red;float: left; opacity: .5;">This document will expire on <b>{{document.file.expireDate | date : 'medium'}}</b></span>
                            </div>
                            <div class="col-md-12 col-sm-12 col-xs-12">
                                <span style="opacity: .5;">Uploaded by <b>{{document.file.createdUser.firstName}} {{document.file.createdUser.lastName}}</b> on <b>{{document.file.createdDate | date : 'medium'}}</b></span>
                            </div>
                        </div>
                        
                        
                    </div>
                </div>


            </div>
            <div class=" col-md-4 col-sm-4">
                <a class="btn btn mygistec-btn-outline" style="font-size: 20px; padding-top: 35px; height: 100px; width: 100%; cursor: pointer;" (click)="downloadFile()">Download Document</a>
            </div>
        </div>

    </div>
</div>
